/**
 * What's Playing Now Component
 */

import { useState, useEffect } from '@wordpress/element';
import { useFilms } from '../context/FilmContext';
import AlertButton from './AlertButton';
import dayjs from 'dayjs';

export default function WhatsPlayingNow() {
    const { fetchWhatsPlaying, loading } = useFilms();
    const [data, setData] = useState(null);

    const t = window.rialtoData?.translations || {};

    useEffect(() => {
        loadData();
        // Refresh every 5 minutes
        const interval = setInterval(loadData, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    const loadData = async () => {
        const result = await fetchWhatsPlaying();
        setData(result);
    };

    if (loading && !data) {
        return (
            <div className="rialto-loading">
                <div className="rialto-spinner"></div>
            </div>
        );
    }

    if (!data?.playing?.length) {
        return null;
    }

    return (
        <div className="rialto-whats-playing">
            <h2 className="rialto-section-title">{t.whatsPlaying || "What's Playing"}</h2>

            <div className="rialto-playing-list">
                {data.playing.map((item) => (
                    <div key={item.screening_id} className="rialto-playing-item">
                        <div className="rialto-playing-time">
                            <span className="rialto-time-value">{item.time}</span>
                            {isNowPlaying(item.datetime, item.duration) && (
                                <span className="rialto-now-badge">NOW</span>
                            )}
                        </div>

                        <div className="rialto-playing-film">
                            {item.film.poster_thumb && (
                                <div className="rialto-playing-poster">
                                    <img src={item.film.poster_thumb} alt={item.film.title} />
                                </div>
                            )}

                            <div className="rialto-playing-info">
                                <h3 className="rialto-playing-title">
                                    <a href={item.film.url}>{item.film.title}</a>
                                </h3>
                                <div className="rialto-film-meta">
                                    {item.film.year && <span>{item.film.year}</span>}
                                    {item.film.genres?.length > 0 && (
                                        <span> | {item.film.genres.join(', ')}</span>
                                    )}
                                </div>
                            </div>

                            <div className="rialto-playing-actions">
                                <AlertButton
                                    screeningId={item.screening_id}
                                    filmTitle={item.film.title}
                                    screeningTime={item.datetime}
                                />
                                <a
                                    href={item.film.url}
                                    className="rialto-btn rialto-btn-secondary rialto-btn-small"
                                >
                                    {t.moreInfo || 'More'}
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

function isNowPlaying(datetime, duration) {
    const start = dayjs(datetime);
    const end = start.add(duration, 'minute');
    const now = dayjs();

    return now.isAfter(start) && now.isBefore(end);
}
